// @need-translate
import {getEnv} from '../../../common/env/env';

export function PaymentService() {
  return (
    <>
      <header>카카오페이지 결제서비스 운영정책</header>
      <main>
        <section>
          <p>
            본 운영정책은{' '}
            <strong className="underline">
              (주)카카오엔터테인먼트(이하“회사”)가 제공하는
              “결제서비스”(카카오페이지 서비스 내의 유료서비스 결제 등을 포함함;
              이하 동일)
            </strong>
            에 적용되는 결제 관련 통합 운영정책으로, 결제서비스 이용 시 발생할
            수 있는 문제 상황에 대해 일관성 있게 대처하기 위하여 운영하고
            있습니다.
          </p>
          <p>
            본 운영정책은 건전한 상거래 환경을 조성하고 안전한 결제서비스 이용을
            위해 여러분이 지켜주셔야 할 세부적인 사항을 규정하고 있으며, 이를
            위반하였거나 그러한 위법·부당한 행위가 있는 것으로 의심될 만한
            상당한 이유가 있는 경우 결제서비스 이용이 제한될 수 있습니다.
          </p>
          <p>
            회사는 합리적인 결제서비스 제공을 위해 세부적인 정책을 변경할 수
            있으며, 변경될 경우 사전에 서비스 공지사항을 통해 공지하도록
            하겠습니다.
          </p>
        </section>
        <hr />
        <section>
          <h2>회원의 권리와 의무</h2>
          <ol>
            <li>
              <p className="text-theme-solid-60">
                <span>1.</span>
                회원의 권리
              </p>
              <p>
                회원의 권리 여러분은 모바일 문의를 통해 결제서비스에 대한 각종
                문의를 포함하여 요청 및 건의를 할 수 있습니다.
              </p>
              <ul>
                <li>[모바일문의] 카카오페이지 앱내 고객센터 (24 시간)</li>
                <li>
                  [온라인문의] 카카오페이지 고객센터(24 시간)
                  <a href={'/ask'} target="_self">
                    {`(${getEnv().webOrigin}/ask)`}
                  </a>
                </li>
                <li>[유선문의] 1644-4755 (평일 10 시 - 19 시)</li>
              </ul>
              <p>
                가. 회사는 결제서비스 이용 시 회원들 간에 발생하는 분쟁 및 회원
                스스로의 과실로 일어난 피해에 대해서는 개입하거나 조치하지
                않습니다. 다만, 서비스를 이용 중 다른 회원의 본 운영정책 위반
                행위로 인해 피해를 입으신 경우, 여러분은 이를 회사에 제보하여
                운영정책의 적용을 요청할 수 있으며 회사는 신고 내용을 확인하고
                운영정책에 따른 제재 조치를 취할 수 있습니다.
              </p>
              <p>
                나. 여러분은 운영정책의 적용 결과가 불만족스러울 경우 언제든지
                모바일 및 온라인문의를 통해 이의를 신청할 수 있습니다
              </p>
            </li>
            <li>
              <p className="text-theme-solid-60">
                <span>2. </span>
                회원의 의무
              </p>
              여러분은 회사가 제공하는 결제서비스 내에서 본 운영정책에서 정하는
              금지행위를 하여서는 아니되며 그 밖에 관련 법령을 위반하는 활동과
              결제서비스 시스템 및 다른 회원의 정상적인 결제서비스 이용을
              방해하는 활동을 하여서는 안 됩니다.
            </li>
          </ol>
        </section>
        <hr />
        <section>
          <h2>회원의 금지행위</h2>
          <ol>
            <li>
              <span>1.</span>
              회원가입 시 개인정보의 전부 또는 일부를 허위로 등록하는 행위
            </li>
            <li>
              <span>2.</span>
              회사가 제공하는 유료서비스 이용방법에 의하지 아니하고 비정상적인
              방법으로 유료서비스를 이용하거나 시스템에 접근하는 행위
            </li>
            <li>
              <span>3.</span>
              타인의 명의, 카드정보, 계좌정보 등을 도용하여 회사가 제공하는
              유료서비스를 이용하는 행위
            </li>
            <li>
              <span>4.</span>
              타인을 속여 대신 결제하도록 하는 행위(지인 또는 기관을 사칭한 피싱
              등)
            </li>
            <li>
              <span>5.</span>
              회원의 접근매체를 매매하거나 양도하는 행위
            </li>
            <li>
              <span>6.</span>
              카카오계정, Daum ID 등을 타인에게 대여하거나 판매, 양도하는 행위
            </li>
            <li>
              <span>7.</span>
              타인에게 대가를 받고 대신 결제하는 행위
            </li>
            <li>
              <span>8.</span>
              회사가 정하지 않은 비정상적인 방법으로 카카오페이지 캐시 또는 쿠폰
              등을 취득하거나 사용하는 행위
            </li>
            <li>
              <span>9.</span>
              회사가 게시한 정보를 무단 변경하거나 또는 회사가 정한 정보 이외의
              정보(컴퓨터 프로그램 등) 등을 송신 또는 게시하는 행위
            </li>
            <li>
              <span>10.</span>
              회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
            </li>
            <li>
              <span>11.</span>
              진정한 구매의사 없이 반복적인 구매 또는 환불을 받는 행위
            </li>
            <li>
              <span>12.</span>
              회사가 제공하는 재화나 서비스를 이용하고자 하는 의사 없이 자금
              융통만을 목적으로 회사의 재화나 서비스를 제 3 자에게 재판매하는
              행위
            </li>
            <li>
              <span>13.</span>
              불법 할인의 목적으로 모바일 교환권을 구매하여 제 3 자에게 판매하는
              행위
            </li>
            <li>
              <span>14.</span>
              정상적으로 결제되지 않고 충전된 카카오페이지 캐시 등을 온라인
              디지털 콘텐츠 구매에 사용한 것이 확인되어 회사가 이용대금을
              청구했으나 불응하는 행위
            </li>
            <li>
              <span>15.</span>
              PG사 또는 구글, 애플, 원스토어 등의 플랫폼 제공업체에서 결제 취소,
              환불 진행 후 또는 온라인 디지털 콘텐츠의 서비스 기한 만료 후
              회수되지 않은 온라인 디지털 콘텐츠를 회사에 신고하지 않고 이용하는
              행위
            </li>
            <li>
              <span>16.</span>
              결제수단을 제공하는 사업자가 지정한 방식으로 이용요금을 납부하지
              않거나 이용요금을 장기 연체하는 경우
            </li>
            <li>
              <span>17.</span>
              다른 회원의 선불전자지급수단 사용을 방해하거나, 회사의
              선불전자지급수단 제공에 지장을 초래하는 행위
            </li>
          </ol>
        </section>
        <section>
          <h2>회원의 결제서비스 이용제한</h2>
          <p>
            여러분의 활동이 관련 법령에 위배되거나, 관련 약관 또는 본 운영정책에
            위반될 경우 회사는 다른 이용자를 피해로부터 보호하기 위해 여러분의
            결제서비스 이용을 제한할 수 있습니다. 또한 본 운영정책에 구체적으로
            해당하지 않는 사항이라고 하더라도 건전한 결제서비스 환경 제공에
            악영향을 끼치거나 다른 이용자에게 불편을 끼치는 행위를 할 경우에도
            여러분의 결제서비스가 이용 제한될 수 있다는 점을 참고해 주시기
            바랍니다.
          </p>
          <p>
            이용 제한은 위반 활동의 누적 정도에 따라 아래와 같이 한시적 제한에서
            영구적 제한으로 단계적 제한하는 것을 원칙으로 하지만{' '}
            <strong className="underline">
              관련 법령에서 금지하는 명백한 불법행위나 타인의 권리침해로서
              긴급한 위험 또는 피해 차단이 요구되는 사안 및 그러한 위법·부당한
              행위가 있는 것으로 의심될 만한 상당한 이유가 있는 경우에 대해서는
              위반 활동 횟수의 누적 정도와 관계 없이 즉시 영구적으로 이용이
              제한될 수도 있다는 점을 유의하여 주시기 바랍니다.
            </strong>
          </p>
          <ul>
            <li>
              최초 적발 시 회원이 가입 시 제공한 전자우편 또는 휴대폰번호로
              부정행위에 대한 주의사항을 안내하며, 이렇게 1 회 주의 안내를 받은
              후에도 다시 부정행위를 한 사실이 적발되는 경우 해당 계정의
              결제서비스 이용이 제한됩니다.
            </li>
            <li>
              <strong className="underline">
                도용, 피싱, 사기 등과 같은 불법행위가 발생했거나 그러한
                불법행위로 의심될 만한 상당한 이유가 있는 경우 사전 주의 안내
                없이 결제서비스 이용이 제한될 수 있습니다.
              </strong>
            </li>
            <li>
              <strong className="underline">
                결제서비스 제한 시 결제 및 충전, 온라인 디지털 콘텐츠 구매,
                환불(카카오계정 탈퇴 시 카카오페이지 캐시 등 캐쉬류 잔액 환불
                포함) 등에 제약이 있을 수 있습니다.
              </strong>
            </li>
          </ul>
        </section>
      </main>
    </>
  );
}
